/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_From_HrInputs */

const en_ui_te_from_hr = /** @type {(inputs: Ui_Te_From_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculated from your heart rate.`)
};

const de_ui_te_from_hr = /** @type {(inputs: Ui_Te_From_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus deinem Puls berechnet.`)
};

/**
* | output |
* | --- |
* | "Calculated from your heart rate." |
*
* @param {Ui_Te_From_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_from_hr = /** @type {((inputs?: Ui_Te_From_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_From_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_from_hr(inputs)
	return de_ui_te_from_hr(inputs)
});